import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class AddItemToFavoriteAPICall extends APICallV4 {
    _method = 'album/element/favorite/set';
    _type: Method = 'post';
}
